import api from '@/api/axios/main.api'

export const fetchRekapan = (data) => {
  return api.get('/v2/persuratan/laporan/daftarunit/'+data.tanggal)
}

export const fetchRekapanByUnit = (data) => {
  return api.get('/v2/persuratan/laporan/daftarunit/'+data.unit+'/'+data.tanggal)
}

export const fetchHariIni = () => {
  return api.get('/v2/persuratan/laporan')
}

export const fetchPerBulan = () => {
  return api.get('/v2/persuratan/laporan/daftar')
}
